import React from 'react';
import { View, Text, Alert, StyleSheet, TouchableOpacity, Image, Dimensions } from 'react-native';

import {connect} from 'react-redux';
import {registerUserAsync} from '../../redux/actions';

import Colors from '../../constants/Colors';
import {SwitchText, ButtonWithSpinner, InformationDialogue} from '../../components';

//TODO(Celso): Change ToS with new update.
const tosLink = 'https://i9-hub-db-hub-bucket.s3-sa-east-1.amazonaws.com/docs/heineken-einstein-lm/devoltaaobar-termos-de-uso.pdf';
const ppLink = 'https://i9-hub-db-hub-bucket.s3-sa-east-1.amazonaws.com/docs/heineken-einstein-lm/devoltaaobar-politica-privacidade.pdf';

class ToSScreen extends React.Component {

    state = {
        isAgreed: false,
        ppAggred: false,
        user: null,

        isRegistering: false,

        errorDialogueVisible: false,
        errorDialogueDescription: "",

        successDialogueVisible: false,
        successDialogueDescription: "",

        dimensions: null,
    };

    controlSwitchValue = (newValue) => {
        this.setState({isAgreed: newValue});
    };

    handleResize = (dimensions) => {
        this.setState({ dimensions: dimensions });
    };

    componentWillUnmount() {
        Dimensions.removeEventListener("change", this.handleResize);
    }

    componentDidMount() {
        const userToRegister = this.props.location.state.userToRegister;
        this.setState({
            user: userToRegister,
            dimensions: {
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight
                }
            }
        });

        Dimensions.addEventListener("change", this.handleResize)
    }

    handleSend = async () => {

        if (!this.state.isAgreed) {
            this.setState({
                errorDialogueVisible: true,
                errorDialogueDescription: 'É necessário concordar com os Termos de Uso para se registrar!'
            })

            return;
        }

        if (!this.state.ppAggred) {
            this.setState({
                errorDialogueVisible: true,
                errorDialogueDescription: 'É necessário concordar com a Política de Privacidade para se registrar!'
            })

            return;
        }

        try {
            this.setState({ isRegistering: true });

            await this.props.registerUserAsync(this.state.user);

            this.setState({  })

            this.setState({
                successDialogueVisible: true,
                successDialogueDescription: 'Seu registro foi realizado com sucesso!'
            })

        } catch (e) {
            console.log(e);

            this.setState({
                errorDialogueVisible: true,
                errorDialogueDescription: 'Aconteceu um erro ao fazer o registro! Tente novamente mais tarde.'
            })
        }

        this.setState({ isRegistering: false });
    };

    render() {

        const height =  this.state.dimensions === null ? '100%' : this.state.dimensions.window.height;
        const width =  this.state.dimensions === null ? '100%' : this.state.dimensions.window.width;

        return (
            <View style={{ alignItems: 'center', backgroundColor: Colors.backgroundColor, padding: 22, width: width, height: height }}>

                <InformationDialogue
                    isModalVisible={this.state.errorDialogueVisible}
                    titleText={"Erro"}
                    descriptionText={this.state.errorDialogueDescription}
                    onClose={() => this.setState({ errorDialogueVisible: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.successDialogueVisible}
                    titleText={"Sucesso"}
                    descriptionText={this.state.successDialogueDescription}
                    onClose={() => this.props.history.push('/')}
                />

                <Image
                    source={require('../../img/logos/logoLogin.png')}
                    style={{ height: 128, width: 128 }}
                    resizeMode={'contain'}
                />

                <TouchableOpacity onPress={() => { window.open(tosLink); }} >
                    <Text style={{
                        fontSize: 18,
                        color: '#48bce9',
                        textDecorationLine: 'underline'
                    }}>
                        Clique para ver os 'Termos de Uso'
                    </Text>
                </TouchableOpacity>

                <SwitchText
                    containerStyleProps={{ marginTop: 6 }}
                    value={this.state.isAgreed}
                    onValueChange={(value) => this.controlSwitchValue(value)}
                    text={'Concordo com o \'Termos de Uso\''}
                />

                <TouchableOpacity onPress={() => { window.open(ppLink) }} >
                    <Text style={{
                        fontSize: 18,
                        color: '#48bce9',
                        textDecorationLine: 'underline'
                    }}>
                        Clique para ver os 'Política de Privacidade'
                    </Text>
                </TouchableOpacity>

                <SwitchText
                    containerStyleProps={{ marginTop: 6 }}
                    value={this.state.ppAggred}
                    onValueChange={(value) => this.setState({ ppAggred: value })}
                    text={'Concordo com a \'Política de Privacidade\''}
                />

                <ButtonWithSpinner
                    isLoading={this.state.isRegistering}
                    text={'Fazer Registro'}
                    containerPropsStyle={styles.buttonContainerStyle}
                    onPress={this.handleSend}
                />
            </View>
        )
    }
}

const styles = StyleSheet.create({
    buttonContainerStyle: {
        marginRight: 30,
        marginLeft: 30,
        marginBottom: 10,
        marginTop: 10,
        borderRadius: 4,
        height: 40,
        width: 300,
        alignSelf: 'center',
    }
});

const mapStateToProps = state => {
    return {
        isFetching: state.auth.isFetching
    }
};

export default connect(mapStateToProps, {registerUserAsync})(ToSScreen);
